import { useState } from 'react'
import { Link } from 'react-router-dom';
import userImg from '../../assets/images/user.png'


const HouseholdMembers = () => {

    return (

        <div className="househld-mem-page pb-4">
            <header role="banner">
                <h1 className='head-title head-bg'><Link to="#" aria-label="Back"><i className='icon-back-arw' aria-hidden="true"></i></Link>Household Members</h1>
            </header>

            <main id="main-content" className='page-padding-x'>
                <ul className='hh-members-list'>
                    <li>
                        <img className='hh-mem-img' src={userImg} alt="" />
                        <div className='hh-mem-list-rght'>
                            <div className='hh-mem-name'>
                                <div>Member Name</div>
                                <div className='hh-mem-profile me'>Me</div>
                            </div>
                            <Link className='hh-mem-edit' to="#" aria-label="Edit Member"><i className='icon-edit' aria-hidden="true"></i></Link>
                        </div>
                    </li>
                    <li>
                        <img className='hh-mem-img' src={userImg} alt="" />
                        <div className='hh-mem-list-rght'>
                            <div className='hh-mem-name'>
                                <div>Member Name</div>
                                <div className='hh-mem-profile'>Parner</div>
                            </div>
                            <Link className='hh-mem-edit' to="#" aria-label="Edit Partner"><i className='icon-edit' aria-hidden="true"></i></Link>
                        </div>
                    </li>
                </ul>
                <Link className='com-btn w-50 mt-4 mx-auto' to="">+ ADD</Link>
            </main>

        </div>
    )
}

export default HouseholdMembers